/* eslint-disable no-unused-vars */
import { axiosInstance } from "../servicesSetupMock";

export const getStatusVA = async () => {
  const { onboarding } = await axiosInstance();
  return onboarding;
};

export const getChecklist = async idUnidade => {
  if (!idUnidade) {
    throw new Error();
  }
  const { checklist } = await axiosInstance();
  return { data: checklist };
};

export const postChecklist = async (checklistList, idUnidade) => {
  if (!idUnidade) {
    throw new Error();
  }
  const { checklist } = await axiosInstance();
  return { data: { checklist }, status: 200 };
};

export const postVistoriaLogin = async (_cpf, _email) => {
  await new Promise(resolve => setTimeout(resolve, 4000));
  const { authVistoriador } = await axiosInstance();
  const parseLocal = localStorage.getItem("TOKEN_NOW");
  if (parseLocal) {
    return JSON.parse(parseLocal);
  }
  return authVistoriador;
};

export const downloadLaudo = async idUnidade => {
  await new Promise(resolve => setTimeout(resolve, 4000));
  const retornoSimulado = {
    type: "application/pdf",
    size: 102400,
    blob: new Blob(["%PDF-1.4\n... Conteúdo Binário Simulado ..."], {
      type: "application/pdf"
    })
  };
  return { data: retornoSimulado.data };
};

export const downloadLaudoNew = async idUnidade => {
  await new Promise(resolve => setTimeout(resolve, 4000));
  const retornoSimulado = {
    type: "application/pdf",
    size: 102400,
    blob: new Blob(["%PDF-1.4\n... Conteúdo Binário Simulado ..."], {
      type: "application/pdf"
    })
  };
  return { data: retornoSimulado.data };
};

export const vaEcDownloads = async idUnidade => {
  if (!idUnidade) {
    throw new Error();
  }
  // await new Promise(resolve => setTimeout(resolve, 10000));
  const { vaEcDownload } = await axiosInstance();
  return vaEcDownload;
};
